'use strict';
(function () {
  angular.module('pentaApp').factory('clubBenefit.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clubBenefit');
  }
})();
